module.exports = __webpack_public_path__ + "static/img/gs_04.f5f3c8d4.jpg";